import { Component } from '@angular/core';
import { concat } from 'rxjs';
import data from '../../../../appsettings.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  version: string = '';

  constructor() {}

  ngOnInit(): void {
    this.version = String(data.versionRelease.portal);
  }
}
